define((require) => {
    "use strict";

    const _ = require("underscore");

    const easingTypes = {
        LINEAR: {
            displayName: "Linear",
            htmlValidName: "linear"
        },
        EASE_IN: {
            displayName: "Ease in",
            htmlValidName: "ease-in"
        },
        EASE_OUT: {
            displayName: "Ease out",
            htmlValidName: "ease-out"
        },
        EASE_IN_OUT: {
            displayName: "Ease in and out",
            htmlValidName: "ease-in-and-out"
        },
        BOUNCE: {
            displayName: "Bounce",
            htmlValidName: "bounce"
        },
        ELASTIC: {
            displayName: "Elastic",
            htmlValidName: "elastic"
        },

        BACK_OUT: {
            displayName: "Back Out",
            htmlValidName: "back-out"
        }
    };

    /**
     * The available easing types.
     *
     * @class EasingTypes
     */
    return _.extend({}, easingTypes, {
        /**
         * Gets the easing types as an array of objects containing displayName and htmlValidName
         * for all of the supported easing types.
         *
         * @returns {Array} array of objects containing displayName and htmlValidName
         * for all of the supported easing types.
         */
        getAsArray() {
            return _.values(easingTypes);
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/animations/EasingTypes.js